module.exports = {

    // CONSTANT WORDS
    'constant.AVERAGE': 'average',

    // Supported languages
    'title.lang.es': 'Spanish',
    'title.lang.en': 'English',

    // Contact Info
    'contact.info.header':           'Contact us',
    'contact.info.phone':            'Phone (Spain toll free)',
    'contact.info.customer_service': '(24x7 customer service)',

    // Entity names
    'entity.task.singular':            'task',
    'entity.task.plural':              'tasks',
    'entity.issue.singular':           'incident',
    'entity.issue.plural':             'incidents',
    'entity.request.singular':         'request',
    'entity.request.plural':           'requests',
    'entity.project.singular':         'project',
    'entity.project.plural':           'projects',
    'entity.reservation.singular':     'AWS reservation',
    'entity.reservation.plural':       'AWS reservations',
    'entity.resource.singular':        'resource',
    'entity.resource.plural':          'resources',
    'entity.account.singular':         'account',
    'entity.account.plural':           'accounts',
    'entity.vendor.singular':          'vendor',
    'entity.vendor.plural':            'vendors',
    'entity.requester.singular':       'user',
    'entity.requester.plural':         'users',
    'entity.company.singular':         'company',
    'entity.company.plural':           'companies',
    'entity.serviceOffering.singular': 'service',
    'entity.serviceOffering.plural':   'services',
    'entity.credential.singular':      'credential',
    'entity.credential.plural':        'credentials',
    'entity.operationLog.singular':    'log',
    'entity.operationLog.plural':      'logs',
    'entity.backup.singular':          'backup',
    'entity.backup.plural':            'backups',
    'entity.plan.singular':            'plan',
    'entity.plan.plural':              'plans',
    'entity.contact.singular':         'contact',
    'entity.contact.plural':           'contacts',
    'entity.rol.singular':             'role',
    'entity.rol.plural':               'roles',
    'entity.aws_ticket.singular':      'ticket',
    'entity.aws_ticket.plural':        'tickets',
    'entity.p200.singular':            'report',
    'entity.p200.plural':              'reports',
    'entity.alert.singular':           'alert',
    'entity.alert.plural':             'alerts',
    'entity.costCenter.singular':      'project',
    'entity.costCenter.plural':        'projects',
    'entity.cost_center.singular':     'project',
    'entity.cost_center.plural':       'projects',
    'entity.product.singular':         'service',
    'entity.product.plural':           'services',
    'entity.region.singular':          'region',
    'entity.region.plural':            'regions',
    'entity.user.singular':            'user',
    'entity.user.plural':              'users',
    'entity.event.singular':           'event',
    'entity.event.plural':             'events',

    // Menu/submenu items

    'title.test':                       'My test',
    'title.subTest':                    'Testing',
    'title.home':                       'Home',
    'title.error':                      'Error',
    'title.sign_in':                    'Sign in',
    'title.recover_password_mail':      'Type in your email',
    'title.recover_password':           'Recover password',
    'title.dashboard':                  'Dashboard',
    'title.infrastructure':             'Cloud Resources',
    'title.service_now':                'EMS support',
    'title.service_now_name':           'Equinix managed support',
    'title.resources':                  'Resources',
    'title.resources.show':             'Show resource: {name}',
    'subtitle.resources.show':          'Created on {date}',
    'title.groups':                     'Groups',
    'title.reports':                    'Cloud Billing',
    'title.reservations':               'AWS reservations',
    'title.consultancy':                'Cloud support',
    'title.internet':                   'Internet access',
    'title.summary':                    'Summary',
    'title.tasks':                      'Tasks',
    'title.issues':                     'Incidents',
    'title.aws_support':                'AWS Support',
    'title.projects':                   'Projects',
    'title.settings':                   'Settings',
    'title.my_profile':                 'My profile',
    'title.my_accounts':                'My accounts',
    'title.my_security_credentials':    'My security credentials',
    'title.view_user_profile':          'View user profile',
    'title.page_not_found':             'Not found!',
    'title.nothing_to_see':             'We are sorry, the content you are trying to access is not available right now.',
    'title.back_to_dashboard':          'Back to dashboard',
    'title.temporary_disabled_account': 'We are sorry, but this account cannot be edited at this moment.',
    'title.alerts':                     'Billing alerts',
    'title.cloudBilling.breakdown':     'Spending breakdown',
    'title.ips':                        'IPS (Infrastructure Platform Service)',
    'title.ips_platform':               'IPS Platform',
    'title.global_information':         'Global Information',
    'title.ips_vcenter':                'VCenter Resources',
    'title.ips_vcloud':                 'VCloud Resources',
    'title.itsm':                       'Support',
    'title.itsm_active_tickets':        'Active tickets',
    'title.itsm_all_tickets':           'Summary tickets',
    'title.itsm_details':               'Details',
    'title.itsm_details_tickets':       'Details tickets',
    'title.cloud':                      'Cloud',
    'title.backupPlatform':             'Backup Platform',
    'title.monitoringPlatform':         'Monitoring',

    // Footer
    'title.help':  'Help',
    'title.about': 'About',
    'title.terms': 'Terms',

    // Login page
    'label.remember_credentials':          'Remember my credentials',
    'label.username':                      'username',
    'label.password':                      'password',
    'label.forgot_password':               'Forgot my password!',
    'label.return_to_login':               'Return to login',
    'label.mail_confirm':                  'You will receive an email soon to {email} with instructions on how to restore your password.',
    'label.password_recovering':           'Your password has been successfully changed. Please, sign in with your new details.',
    'label.password_policy.header':        'The password must meet the following requirements:',
    'label.password_policy.requirement.1': 'It must contain at least 12 characters.',
    'label.password_policy.requirement.2': 'Must contain uppercase, lowercase, numbers and special characters.',
    'label.password_policy.requirement.3': 'Cannot contain your username or your email address',
    'label.password_policy.requirement.4': 'It cannot be the same as the last 5 passwords',
    'label.password_policy.error':         'The password you input does not meet the requirements.',
    'btn.sign_in':                         'Sign in',
    'btn.signing_in':                      'Signing in...',

    // Consultancy
    'title.hours_by_customer':                  'Hours by customer',
    'title.recent_projects':                    'Recently active projects',
    'title.recent_issues':                      'Recently active incidents (in progress)',
    'title.latest_tasks':                       'Latest completed tasks',
    'title.name':                               'Name',
    'title.hours':                              'Hours',
    'title.hours_abbr':                         'Hrs',
    'title.project':                            'Project',
    'title.progress':                           'Progress',
    'title.issue':                              'Incident',
    'title.status':                             'Status',
    'title.issue_level':                        'Priority level',
    'title.assigned_to':                        'Assigned to',
    'title.consultant':                         'Consultant',
    'title.consultants':                        'Consultants',
    'title.total':                              'Total',
    'title.customers':                          'Customers',
    'title.manager':                            'Manager',
    'title.description':                        'Description',
    'label.hours':                              'hours',
    'label.number_hours':                       '{num, plural, one {# hr} other {# hrs}}',
    'label.view_all_projects':                  'View all projects',
    'label.view_all_issues':                    'View all incidents',
    'label.task_completed_on_date':             'Tasks completed on {date}',
    'label.completed_by_person_on_date':        'Completed by {person} {others, plural, =0 {} other {(and # more)}} {date}',
    'label.related_to_issue_issue':             ', related to the incident {issue}',
    'label.opened_by_person_on_date':           'Opened by {person} on {date}',
    'label.person_completed_task_on_date':      '{others, plural, one {{person} completed} other {# consultants completed}} task {task} {date}',
    'label.displaying_count_entities_criteria': 'Displaying {count} {entities} according to your search criteria.',
    'label.there_are_count_entities_total':     'There are {count} {entities} in total.',
    'label.there_are_no_entities_criteria':     'There are no {entities} that satisfy your search criteria.',
    'label.there_are_no_entities':              'There are no {entities} on the system.',
    'label.there_are_no_entities.female':       'There are no {entities} on the system.',
    'label.tasks':                              'Task',
    'label.task_types':                         'Task types',
    'label.all_task_types':                     'All task types',
    'label.all_projects':                       'All projects',
    'label.paren_unknown_paren':                '(Unknown)',
    'label.search':                             'Search',
    'label.search.selection':                   'Search inside selection',
    'title.search':                             'Type at least %s characters to begin search.',
    'placeholder.search_tasks':                 'Task name, description...',
    'label.all_statuses':                       'All statuses',
    'label.all_states':                         'All states',
    'label.state':                              'State',
    'label.statuses':                           'Statuses',
    'label.all_levels':                         'All levels',
    'label.datepicker':                         'Datepicker',
    'label.levels':                             'Levels',
    'label.all_vendors':                        'All vendors',
    'label.vendors':                            'Vendors',
    'label.all_task':                           'All task',
    'label.task':                               'Tasks',
    'label.all_accounts':                       'All accounts',
    'label.accounts':                           'Accounts',
    'placeholder.account.search':               'Account name...',
    'placeholder.vendor.search':                'Vendor name...',
    'placeholder.costCenter.search':            'Project name...',
    'label.accounts.credentials':               'Credentials',
    'label.all_resource_types':                 'All resource types',
    'label.resource_types':                     'Resource types',
    'btn.add_resource':                         'New resource',
    'placeholder.search_resources':             'Resource ID, resource name',
    'label.select_resources':                   'Select resources',
    'dropdown.all':                             'All',
    'dropdown.active':                          'Running',
    'dropdown.stopped':                         'Stopped',
    'dropdown.none':                            'None',
    'btn.add_associated_service':               'Add associated service',
    'btn.create_backup_job':                    'Create backup job',
    'btn.start':                                'Start',
    'btn.stop':                                 'Stop',
    'btn.refresh_page':                         'Refresh',
    'btn.discover':                             'Discover',
    'btn.discover.counter':                     'Discover ({count})',
    'btn.resouces.click_to_discover':           'Click here to run the discovery process',
    'btn.start_resource':                       'Start resource',
    'btn.stop_resource':                        'Stop resource',
    'btn.reset_filter':                         'Reset filters',
    'btn.request_service_installation':         'Request service installation',
    'btn.add_service':                          'Add service',
    'btn.add':                                  'Add',
    'btn.remove':                               'Remove',
    'btn.terminateResource':                    'Terminate resource',
    'btn.page':                                 'Page',

    'btn.add_issue':                                    'Add incident',
    'btn.cancel_issue':                                 'Cancel incident',
    'btn.reactiveIssue':                                'Reactive incident',
    'btn.reopenIssue':                                  'Reopen incident',
    'btn.submit_issue':                                 'Submit incident',
    'btn.submit_button':                                'Submit',
    'btn.closeIssue':                                   'Close incident',
    'placeholder.search_issues':                        'Incident name, incident id, description...',
    'placeholder.search_requests':                      'Request name, request id, description...',
    'label.select_level':                               'Select level',
    'label.select_project':                             'Select project',
    'label.edit':                                       'Edit',
    'label.person_commented_ago':                       '{person} commented {ago}',
    'label.active_projects':                            'Active projects',
    'label.closed_projects':                            'Closed projects',
    'label.any_status':                                 'Any status',
    'placeholder.search_projects':                      'Project name, description...',
    'placeholder.projects.search':                      'Project name...',
    'label.all_customers':                              'All customers',
    'label.close':                                      'Close',
    'label.all_consultants':                            'All consultants',
    'form.issue.title.label':                           'Title',
    'form.issue.title.placeholder':                     'In a few words, answer: What is the claim? or "What must be done?"',
    'form.issue.title.placeholder.mobile':              '"What is the problem?" or "What must be done?"',
    'form.issue.title.error.is_required':               'Please enter a title for this incident',
    'form.issue.title.error.must_be_max_length':        "Title shouldn't be more than 30 characters",
    'form.validation.must_be_min_length':               'The field should have at least {min} characters',
    'form.validation.must_contain_uppercase':           'The field should contain at least one uppercase character',
    'form.validation.must_contain_lowercase':           'The field must contain at least one lowercase character',
    'form.validation.must_contain_numbers':             'The field must contain at least one numeric value',
    'form.validation.must_contain_special_character':   'The field must contain at least one special character',
    'form.issue.callerId.modal.label':                  'Requester',
    'form.issue.callerId.placeholder':                  'Select a requester',
    'form.issue.callerId.modal.title':                  'Select a requester',
    'form.issue.callerId.modal.selected.callerid':      'Selected requester',
    'form.issue.company.label':                         'Company',
    'form.issue.company.placeholder':                   'Please select a company',
    'form.issue.impact.label':                          'Impact',
    'form.issue.impact.placeholder':                    'Impact',
    'form.issue.comment.label':                         'Comment',
    'form.issue.comment.placeholder':                   'Describe the incident in as many details as desired.',
    'form.issue.comment.error.is_required':             'Please enter a comment',
    'form.issue.service_offering.label':                'Service offering',
    'form.issue.service_offering.placeholder':          'Please, select a service offering',
    'form.issue.service_offering.placeholder.disable':  'Please, select a company and requester',
    'form.issue.service_offering.modal.title':          'Service offering',
    'form.issue.service_offering.modal.selecteduser':   'Selected service offering',
    'form.issue.id_ticket_customer.label':              'Customer ticket ID',
    'form.issue.id_ticket_customer.placeholder':        'Customer ticket ID',
    'form.issue.service_now_users.label':               'Watch list',
    'form.issue.service_now_users.placeholder':         'Select items to add to the watch list',
    'form.issue.service_now_users.modal.title':         'Select items to add to the watch list',
    'form.issue.service_now_users.placeholder.mobile':  'Select items to add to the watch list',
    'form.issue.service_now_users.modal.selectedusers': 'Selected users',
    'form.issue.service_offering.help':                 'How important is it to solve this incident?',
    'form.issue.service_offering.error.empty':          'Please select service offering',
    'form.issue.watchList.modal.selecteduser':          'Selected users',
    'form.issue.customer_project.label':                'Project',
    'form.issue.customer_project.help':                 'Which project is this issue related to?',
    'form.issue.customer_project.error.is_required':    'Please select a related project',
    'form.issue.submit':                                'Save and stay',
    'form.request.submit':                              'Save and stay',
    'form.request.title.placeholder':                   'In a few words, answer: "What do you need?"',
    'form.request.title.placeholder.mobile':            'What do you need?',
    'form.request.comment.placeholder':                 'Describe  request in as many details as desired.',
    'label.person_opened_issue_issue':                  '{person} opened incident {issue}',
    'label.person_opened_task_task':                    '{person} opened task “{task}”',
    'label.person_closed_task_task':                    '{person} closed task “{task}”',
    'label.task_completed_in_hours':                    'Completed in {hours, plural, one {# hour} other {# hours}}',
    'label.not_assigned':                               'Not assigned',
    'label.service_offering':                           'Service offering',

    // Reservations
    'label.active':                    'Active',
    'label.retired':                   'Retired',
    'label.all_regions':               'All regions',
    'label.regions':                   'Regions',
    'label.all_instance_types':        'All instance types',
    'label.instance_type':             'Instance Type',
    'label.all_products':              'All products',
    'label.products':                  'Products',
    'placeholder.search_reservations': 'AWS reservation ID',
    'title.reservation_id':            'AWS reservation ID',
    'title.product':                   'Product',
    'title.account':                   'Account',
    'title.region':                    'Region',
    'title.instance_type':             'Instance type',
    'title.quantity_abbr':             'Qty.',
    'title.quantity':                  'Quantity',
    'title.accounts':                  'Accounts',
    'title.all_accounts':              'All accounts',
    'label.select_item_for_detail':    'Select an item from the listing\nfor further detail.',
    'btn.retire_reservation':          'Remove AWS reservation',
    'title.usage_last_10_days':        'Usage last 10 days',
    'title.account_name':              'Account name',
    'title.offering_type':             'Offering tipe',
    'title.instance_count':            'Instance count',
    'title.start_date':                'Start date',
    'title.end_date':                  'End date',
    'title.last_update':               'Last update',
    'label.date_at_time':              '{date} at {time}',
    'entity.reservations.singular':    'AWS reservation',
    'entity.reservations.plural':      'AWS reservations',

    // User
    'msg.you_have_no_accounts':                                    'You have no accounts.',
    'msg.you_dont_have_credentials_to_discover':                   "You don't have any security credential to run the discovery process.",
    'msg.need_discover':                                           'The discovery process has not been run yet.',
    'title.add_credential_now':                                    'Add a security credential',
    'title.account_id':                                            'Account ID',
    'title.tags':                                                  'Tags',
    'title.edit_account_acctname':                                 'Edit account "{acctname}"',
    'title.new_account':                                           'New account',
    'title.new_credential':                                        'New credential',
    'btn.save_changes':                                            'Save changes',
    'btn.add_account':                                             'Add account',
    'btn.cancel':                                                  'Cancel',
    'btn.back':                                                    'Back',
    'form.account.submit':                                         'Save and stay',
    'form.account.name.label':                                     'Account name',
    'form.account.name.help':                                      'The full name of the account',
    'form.account.name.error.is_required':                         'Please, enter a name for this account',
    'form.account.vendor.label':                                   'Vendor',
    'form.account.account_id.label':                               'Account ID',
    'form.account.account_id.help':                                'The AWS account ID',
    'form.account.account_id.error.is_required':                   'Please, enter an account ID',
    'form.account.azure_csp.customerId.label':                     'Customer ID',
    'form.account.azure.currency.label':                           'Currency ISO',
    'form.account.azure.currency.placeholder':                     'EUR, USD, etc.',
    'form.account.azure.purchased.label':                          'Offer purchased country ISO',
    'form.account.azure.offer.label':                              'Offer ID',
    'form.account.azure.offer.placeholder':                        'Ex: ms-azr-0025p',
    'form.account.azure.locale.label':                             'Locale', //no hay traduccion y no coincide con la version en español
    'form.account.azure.locale.placeholder':                       'Ex: en-EN',
    'form.account.azure_csp.id.label':                             'Subscription ID',
    'form.account.aws.id.label':                                   'AWS account ID',
    'form.account.alicloud.id.label':                              'Ali Cloud account ID',
    'form.account.gcloud.id.label':                                'Google Cloud account ID',
    'form.account.oracle.id.label':                                'Oracle Cloud account ID',
    'form.account.oracle.id.placeholder':                          'Ex: cacct-a1bt67f3bn17a1ytc1drt598a06b32a2',
    'form.account.oracle.identityId.label':                        'Identity Service ID',
    'form.account.oracle.identityId.placeholder':                  'Ex: idcs-arf67vf3abjn012f88d12098pq6b32a3',
    'form.account.aws.id.placeholder':                             'Format: 12345678901',
    'form.account.alicloud.id.placeholder':                        'Format: 12345678901',
    'form.account.google.id.placeholder':                          'Format: 1111AA-11B11A-112223',
    'msg.you_sure_delete_credential':                              'Are you sure you want to delete this credential?',
    'msg.credential_already_exists':                               'A credential for this service and this account already exists.',
    'btn.add_credential':                                          'Add credential',
    'msg.you_have_no_credentials':                                 "You don't have any credential. Add one?",
    'securityCredential.alias':                                    'Name',
    'securityCredential.vendor':                                   'Vendor',
    'table.securityCredential.alias':                              'Name',
    'table.securityCredential.service':                            'Service',
    'table.securityCredential.account':                            'Account',
    'table.securityCredential.vendor':                             'Vendor',
    'title.add_credential':                                        'Add a security credential',
    'form.securityCredential.alias.label':                         'Alias',
    'form.securityCredential.alias.help':                          'An alias for reference purposes.',
    'form.securityCredential.alias.error.is_required':             'Please, enter an alias for this credential',
    'form.securityCredential.alias.error.must_be_max_length':      'The alias is too long (max. 50)',
    'form.securityCredential.account.label':                       'Account',
    'form.securityCredential.account.id.label':                    'Account ID',
    'form.securityCredential.account.help':                        'AWS account this credential is related to',
    'form.securityCredential.account.error.is_required':           'Please, enter the account',
    'form.securityCredential.service.label':                       'Service',
    'form.securityCredential.service.help':                        'What AWS service this key is for',
    'form.securityCredential.service.error.is_required':           'Please select a service',
    'form.securityCredential.access_key.label':                    'Access key',
    'form.securityCredential.access_key.error.is_required':        'Please, enter the access key',
    'form.securityCredential.access_key.error.must_be_max_length': 'The access key is too long (max. 20)',
    'placeholder.select_account':                                  'Select an account',
    'placeholder.select_service':                                  'Select a service',
    'label.superuser':                                             'superuser',
    'label.staff':                                                 'staff',
    'label.consultant':                                            'consultant',
    'label.inactive':                                              'inactive',
    'title.username':                                              'Username',
    'title.password':                                              'Password',
    'title.password_confirm':                                      'Confirm password',
    'title.email':                                                 'E-mail',
    'title.last_login':                                            'Last login',
    'login.token_invalid':                                         'Your password change request has expired',
    'login.invalid_password':                                      'Please, verify that your passwords match',
    'login.empty_password':                                        'Please, verify that your passwords are not empty',
    'login.bad_request':                                           'Could not connect, verify your internet connection.',
    'login.back_to_login':                                         'Back to login',
    'title.language':                                              'Language',
    'label.change':                                                'change',
    'title.profile':                                               'Profile',
    'title.credentials':                                           'Credentials',
    'title.sign_out':                                              'Sign out',
    'msg.no_new_notifications':                                    "You don't have new notifications",
    'msg.remove_credential_ok':                                    'The credential {credential} has been deleted',

    // reports
    'title.by_vendor':             'By Vendor',
    'title.by_account':            'By Account',
    'title.by_cost_center':        'By Project',
    'reports.button.closeTab':     'Close tab',
    'reports.button.closeAllTabs': 'Close all tabs',
    'help.reports.search':         'Search by item',
    'reports.search.cost_center':  'Filter by project',
    'reports.search.vendor':       'Filter by vendor',
    'reports.search.account':      'Filter by accounts',
    'btn.print':                   'Print',
    'btn.show_all':                'Show all',

    //Resources
    'label.resources.vendor':        'Vendor',
    'label.resources.resourceType':  'Resource type',
    'label.resources.group':         'Group',
    'label.resources.region':        'Region',
    'label.resources.status':        'Status',
    'label.resources.lastUpdate':    'Last update',
    'label.resources.account':       'Account',
    'label.resources.resourceGroup': 'Resource group',
    'label.resources.resource':      'Resource',
    'label.resources.id':            'ID',
    'label.resources.instanceType':  'Instance type',
    'label.resources.services':      'Marketplace',
    'label.resources.msp':           'MSP',
    'label.resources.service':       'Service',
    'label.resources.version':       'Version',
    'label.resources.description':   'Description',
    'label.resources.errorMessage':  'You are disconnected from the Internet or the server is unreachable. Please, try again in a few minutes.',
    'label.resources.instanceUsage': 'Instance usage',
    'label.resources.mac_address':   'MAC address',
    'label.resources.private_ip':    'Private IP',
    'label.resources.public_ip':     'Public IP',
    'label.resources.cpuUsage':      'CPU usage',
    'label.resources.cpu':           'CPU',
    'label.resources.size':          'Size',
    'label.resources.mountpoint':    'Mount point',
    'label.resources.task':          'Task',
    'label.resources.error':         'Error',
    'label.resources.showMore':      'Show more',
    'label.resources.textLink':      'From Cloudmas and AWS, we are committed to provide a continuous service and security of the services provided . For more information, click on the following link ##link##',
    'label.resources.link':          'here',

    'msg.operationDiscover.STATUS_QUEUED':        'Checking configurations for service discovery',
    'msg.operationDiscover.STATUS_LAUNCHED':      'Launching tasks. This operation may take a few minutes. Please, come back later to check these resources.',
    'msg.operationDiscover.STATUS_SUCCESS':       'The resources have been found. You may find them in the table below.',
    'msg.operationDiscover.STATUS_FAIL':          'There was an error',
    'msg.operationDiscover.STATUS_UNKNOWN':       'There was an error',
    'msg.operationDiscover.STATUS_AWS_FAILED':    'There was an internal error saving AWS resources. Check your credentials',
    'msg.operationDiscover.STATUS_AZURE_FAILED':  'There was an internal error saving AZURE resources. Check your credentials',
    'msg.operationDiscover.STATUS_VCLOUD_FAILED': 'There was an internal error saving VCLOUD resources. Check your credentials',

    // AWS Reservations
    'label.reservations.id':           'AWS reservation ID',
    'label.reservations.product':      'Product',
    'label.reservations.account':      'Account',
    'label.reservations.region':       'Region',
    'label.reservations.instanceType': 'Instance type',
    'label.reservations.qty':          'Quantity',
    'label.reservations.state':        'State',
    'label.reservations.startDate':    'Start date',
    'label.reservations.endDate':      'End date',
    'label.reservations.offeringType': 'Payment option',
    'label.reservations.stopped':      'Retired',
    'label.reservations.active':       'Actived',
    'label.reservations.duration':     'Duration',

    // Reservations plurals
    'time.year.one':   'year',
    'time.month.one':  'month',
    'time.week.one':   'week',
    'time.day.one':    'day',
    'time.hour.one':   'hour',
    'time.minute.one': 'minute',
    'time.second.one': 'second',

    'time.year.other':   'years',
    'time.month.other':  'months',
    'time.week.other':   'weeks',
    'time.day.other':    'days',
    'time.hour.other':   'hours',
    'time.minute.other': 'minutes',
    'time.second.other': 'seconds',

    'dropdown.clear': 'Clear',

    'title.resources.installed_services':          'Installed services',
    'title.resources.associated_managed_services': 'Associated managed services',

    'label.status.0': 'Terminated',
    'label.status.1': 'Active',
    'label.status.2': 'Stopped',
    'label.status.3': 'Unknown',
    'label.status.4': 'Waiting',
    'label.status.5': 'Warning',

    //IaaS Dashboard
    'iaas.topwidget.cpu.title':     'CPU',
    'iaas.topwidget.ram.title':     'RAM',
    'iaas.topwidget.storage.title': 'Storage',
    'iaas.topwidget.vm.title':      'Virtual Machines',
    'iaas.esx.title':               'Hypervisor data',
    'iaas.esx.select.message':      'Select an hypervisor',
    'iaas.search':                  'Search...',
    'api.error':                    'API Error',
    'title.alert.api':              'API',
    'iaas.cta':                     'Get more resources',
    'iaas.current.vm':              'Current virtual machines',
    virtualMachines:                'Virtual machines',
    inUse:                          'In use',
    vmLast12Header:                 'Virtual machines last 12 months',
    totalVirtualMachines:           'Total virtual machines',
    vmName:                         'Virtual Machine',
    statusVm:                       'State',
    cpuVm:                          'CPU',
    ramVm:                          'RAM',
    storageVm:                      'Storage',
    activeVm:                       'Active',
    inactiveVm:                     'Inactive',
    vdcClient:                      'VDC Client',
    guestOs:                        'Guest OS',
    selectVCenter:                  'Select VCenter',
    selectVdcClient:                'Select VDC',
    selectGuestOs:                  'Select OS',
    'iaas.modal.title':             'Do you need more resources?',
    'iaas.modal.subTitle':          'Hello',
    'iaas.modal.content':           'To request information about this service or you need more resources, please get in touch with your assigned Account Executive or send an email to',
    'extra.information.iaas':       '* These data are acquired from the last measurement of the month',
    'alert.information.iaas':       'Information based only on consumption',
    selectCluster:                  'Select cluster',
    selectHypervisor:               'Select hypervisor',
    selectItemsPerPage:             'Items per page',
    'iaas.service.is.not.in.use':   'The service is not being used.',

    // ITSM Dashboard
    'itsm.tickets.by.state':        'Tickets by state',
    'itsm.state':                   'State',
    'itsm.number':                  'Number',
    'itsm.type':                    'Type',
    'itsm.urgency':                 'Urgency',
    'itsm.impact':                  'Impact',
    'itsm.opened':                  'Opened',
    'itsm.closed':                  'Closed',
    'itsm.responseTime':            'Response (min)',
    'itsm.resolutionTime':          'Resolution (hr)',
    'itsm.lastUpdate':              'Last Update',
    'itsm.openedBy':                'Opened By',
    'itsm.shortDescription':        'Short Description',
    'itsm.selectState':             'Select State',
    'itsm.selectType':              'Select Type',
    'itsm.trouble':                 'Trouble',
    'itsm.servicerequest':          'Service request',
    'itsm.troublebyimpact':         'Current month trouble by impact',
    'itsm.servicerequestbyurgency': 'Current month service request by urgency',
    'alert.information.itsm':       'Data for inquiries only. If you need to manage tickets, please access the ECP Portal ',
    'itsm.impact.p1.legend':        'Affects a large number of users or customer, interrupt business, and affect service delivery',
    'itsm.impact.p2.legend':        'Affects a few staff and interrup wprk to some degree',
    'itsm.impact.p3.legend':        'Users and business are impacted but not interrupted',
    'itsm.urgency.p1.legend':       'If the service request is not treated quickly a critical service will be unavailable for all users',
    'itsm.urgency.p2.legend':       'A service or system might be impacted if the service request is not treated',
    'itsm.urgency.p3.legend':       'It is a service request that might be planned to be executed. There is a low impact on the business',


    // InfrastructureResourceShowTechnicalDetail
    'label.technicalDetails.title':            'Technical Details',
    'label.technicalDetails.networks':         'Networks',
    'label.technicalDetails.instance_details': 'Instance details',
    'label.technicalDetails.mac_address':      'Mac address',
    'label.technicalDetails.private_ip':       'Private IP',
    'label.technicalDetails.public_ip':        'Public IP',
    'label.technicalDetails.volumes':          'Volumes',
    'label.technicalDetails.operation_logs':   'Operation logs',
    'label.technicalDetails.size':             'Size',
    'label.technicalDetails.id':               'ID',
    'label.technicalDetails.nodata':           'No data',
    'label.technicalDetails.internetUse':      'Internet use',
    'dropdown.internetUse.port1':              'Port 1',
    'dropdown.internetUse.port2':              'Port 2',
    'dropdown.internetUse.allports':           'All ports',
    'label.technicalDetails.bandWidth':        'Bandwidth',
    'label.technicalDetails.port':             'Port',
    'label.technicalDetails.redundancy':       'Redundacy',
    'label.technicalDetails.ips':              'IP\'s',
    'label.technicalDetails.nic_name':         'NIC name',

    'label.security_credentials.accounts':        'Accounts',
    'label.security_credentials.credentials':     '{account} credentials',
    'label.security_credentials.accounts_vendor': '{vendor} accounts',

    'resource.action.start': 'The resource is pending to be started',
    'resource.action.stop':  'The resource is pending to be stopped',

    'table.msg_no_data': 'There is no data.',

    'chart.products.others':             'Others',
    'report.title.spendingbreakdown':    'Spending breakdown',
    'report.subtitle.spendingbreakdown': 'Product spending by {concept}',
    'report.series.vendors':             'Vendors',
    'report.series.accounts':            'Accounts',
    'report.series.products':            'Products',
    'report.series.cost_center':         'Project',
    'report.series.regions':             'Regions',
    'report.series.drilluptext':         'Back to {series}',
    'report.table.name':                 'Name',
    'report.table.totalcosts':           'Total costs',
    'report.table.total':                'TOTAL',
    'report.table.footer':               'Estimated cost from {start} to {end}',
    'report.spending.vendor':            'vendor',
    'report.spending.cost_center':       'project',
    'report.spending.account':           'account',
    'report.spending.usage':             'Usage',
    'report.spending.total':             'Total',

    'dashboard.breakdown.account':                  'By account',
    'dashboard.breakdown.vendor':                   'By vendor',
    'dashboard.breakdown.productArea':              'By product area',
    'dashboard.breakdown.costCenter':               'By project',
    'dashboard.spending12.title':                   'Spending last 12 months',
    'dashboard.breakdown.title':                    'Daily spent',
    'dashboard.breakdown.total':                    'Total spending for period',
    'dashboard.breakdown.prev':                     'Previous month',
    'dashboard.breakdown.change':                   'Change',
    'dashboard.breakdown.footer':                   'Values rounded to the nearest dollar.',
    'dashboard.topwidget.product_area.title':       'Top product areas',
    'dashboard.topwidget.cost_center.title':        'Top projects',
    'dashboard.topwidget.account.title':            'Top cost accounts',
    'dashboard.topwidget.show.chart':               'Show chart',
    'dashboard.topwidget.hide.chart':               'Hide chart',
    'dashboard.topwidget.predictions.title':        'Current month forecast by vendor',
    'label.topwidget.table.name':                   'Name',
    'label.topwidget.table.total_costs':            'Total cost',
    'label.topwidget.table.prediction.name':        'Vendor',
    'label.topwidget.table.prediction.total_costs': 'Forecast',

    'label.notavailable':   'N/A',
    'label.type_to_search': 'Type to search',

    // Hired Products
    'label.hired.products.title':              'Hired products',
    'label.hired.products.asset_desc':         'Product',
    'label.hired.products.asset_id':           'Asset ID',
    'label.hired.products.product_id':         'Product ID',
    'label.hired.products.desc_element':       'Asset description',
    'label.hired.products.tier':               'Tier',
    'label.hired.products.iops':               'IOPS',
    'label.hired.products.uom':                'UOM',
    'label.hired.products.type':               'Type',
    'label.hired.products.volume':             'Volume (GB)',
    'label.hired.products.quantity':           'Quantity',
    'label.hired.products.consumption':        'Consumption',
    'label.hired.products.comercial_model':    'Comercial mode',
    'label.hired.products.backup_retention':   'Backup Protection',
    'label.hired.products.typr_of_monitoring': 'Type of monitoring',


    // Consultancy
    'label.issues.createUser':           'Created by',
    'label.issues.incident':             'Incident',
    'label.requests.request':            'Request',
    'label.issues.company':              'Company',
    'label.issues.comments':             'Comments',
    'label.issues.title':                'Title',
    'label.issues.priority':             'Priority',
    'label.issues.tag_state':            'State',
    'label.issues.datetime':             'Datetime',
    'label.issues.openedAt':             'Opened',
    'label.issues.account_name':         'Account name',
    'label.issues.totalMessages':        'Total messages',
    'label.issues.created_message':      'Created by ##creationUserName## at ##date##, ##dateMessage##',
    'label.issues.activityComments':     '##totalMessages## ##formatTotalMessage##',
    'label.issues.singularComment':      'comment',
    'label.issues.pluralComment':        'comments',
    'label.issues.assignedToTooltip':    'Assigned to ##responsibleUser.name##',
    'label.issues.createdPersonTooltip': 'Created by ##creationUserName##',
    'label.issues.requester':            'Requester',
    'label.issues.status':               'Status',
    'label.issues.level':                'Level',
    'label.issues.assignedTo':           'Assigned to',
    'label.issues.openedBy':             'Opened by:',
    'label.issues.closedBy':             'closed the incident',
    'label.issues.commented':            'commented',
    'label.issues.comment':              'Add a comment',
    'label.issues.impact':               'Impact',
    'label.issues.description':          'Description',
    'label.all_issues_status':           'Any status',
    'label.issues_status':               'Status',
    'label.all_priorities':              'All priorities',
    'label.priority':                    'Priority',
    'label.issues.status.1':             'Open',
    'label.issues.status.2':             'In progress',
    'label.issues.status.3':             'Completely closed',
    'label.issues.status.4':             'Uncompletely closed',
    'label.issues.status.-5':            'Pending',
    'label.issues.status.7':             'Closed by ommission',
    'label.issues.status.500':           'Closed re-attempt',
    'label.issues.status.501':           'Closed continuation',
    'label.issues.status.502':           'Closed annulment',

    //Plans
    'title.jobplans':             'Job / Plans',
    'title.backups':              'Backup',
    'backups.perday':             'Backups per day',
    'title.plans':                'Plans',
    'label.plans.name':           'Name',
    'label.plans.schedule':       'Schedule',
    'label.plans.next_run':       'Next run',
    'label.plans.last_run':       'Last run',
    'label.plans.enable':         'Enable',
    'placeholder.search_plans':   'Name...',
    'label.all_schedules':        'All schedules',
    'label.schedules':            'Schedules',
    'btn.add_plan':               'Add plan',
    'btn.remove_plan':            'Remove plan',
    'label.select_plans':         'Select plans',
    'entity.plans.singular':      'plan',
    'entity.plans.plural':        'plans',
    'label.enable':               'Enable',
    'label.disable':              'Disable',
    'template.undefined':         '<<to define>>',
    'template.plans.now':         'Right now',
    'template.plans.once':        'Once only on ##date## at ##time##',
    'template.plans.every':       'Every day at ##time## from ##start## to ##end##',
    'template.plans.every-never': 'Every day at ##time## since ##start##',
    'template.plans.week':        'Every ##dayWeek## at ##time## from ##start## to ##end##',
    'template.plans.week-never':  'Every ##dayWeek## at ##time## since ##start##',
    'template.plans.month':       'On the ##dayMonth## of every month at ##time## from ##start## to ##end##',
    'template.plans.month-never': 'On the ##dayMonth## of every month at ##time## since ##start##',
    'dropdown.schedules.once':    'Once only',
    'dropdown.schedules.every':   'Every day',
    'dropdown.schedules.week':    'Every week',
    'dropdown.schedules.month':   'Every month',
    'label.execution.success':    'success',
    'label.execution.queued':     'queued',
    'label.execution.launched':   'launched',
    'label.execution.failed':     'failed',
    'label.execution.unknown':    'unknown',

    'label.dropdown.type.month': 'Month ',
    'label.dropdown.type.date':  'Day ',

    //Customer Service Center
    'title.csc':                    'CSC',
    'title.contacts':               'Contacts',
    'title.contacts_new':           'New contact',
    'btn.add_contact':              'New contact',
    'btn.remove_contact':           'Remove contact',
    'label.contacts.id':            'Customer ID',
    'label.contacts.customer':      'Customer',
    'label.contacts.contact':       'Contact',
    'label.contacts.roles':         'Roles',
    'label.contacts.dni':           'ID / DNI',
    'label.contacts.buildings':     'Buildings',
    'label.contact.edit':           'Edit contact',
    'placeholder.search_contacts':  'ID, Name, Fullname, Phone, Email, DNI',
    'label.all_roles':              'All roles',
    'label.roles':                  'Roles',
    'label.all_buildings':          'All buildings',
    'label.buildings':              'Buildings',
    'label.select_contacts':        'Select contacts',
    'form.contact.fullName.label':  'Full name',
    'form.contact.fullName.help':   'Full name',
    'form.contact.phone.label':     'Phone number',
    'form.contact.phone.help':      'Phone number',
    'form.contact.email.label':     'E-mail address',
    'form.contact.email.help':      'E-mail address',
    'form.contact.dni.label':       'DNI',
    'form.contact.dni.help':        'DNI',
    'form.contact.roles.label':     'Roles',
    'form.contact.buildings.label': 'Buildings',
    'form.contact.id.label':        'Customer Id',
    'form.contact.shortName.label': 'Customer name',
    'form.contact.details.label':   'Contact details',
    'form.contact.submit':          'Save and Stay',
    'table.contact.roles.code':     'Rol code',
    'table.contact.roles.name':     'Rol name',

    // Plurals
    'label.comments.one':  'comment',
    'label.comments.many': 'comments',

    'form.validation.must_be_max_length': 'It cannot contain more than {maxlength} characters',
    'form.validation.empty':              'It cannot be empty',
    'form.validation.do_no_match':        'It must match to \'{field}\'',
    'form.validation.invalid_exp':        'It must match to pattern \'{pattern}\'',
    'form.default.submit':                'Submit',
    'form.default.reset':                 'Reset',
    'form.default.cancel':                'Back',
    'form.default.saveAddAnother':        'Save and add another',
    'form.default.save':                  'Save and back',
    'form.default.saveAndStayText':       'Save and stay',
    'form.remove':                        'Remove',
    'form.close':                         'Close',
    'form.logDetails':                    'Log details',
    'info.file_input.max':                'Max amount of files to attach: {max}',
    'info.file_input.size':               'Max size of each file to attach: {max}',

    'label.accounts.vendor':       'Vendor',
    'label.accounts.name':         'Account name',
    'placeholder.search_accounts': 'Name...',

    'form.credential.alias.label':                           'Alias',
    'form.credential.id.label':                              'Account ID',
    'form.credential.account.label':                         'Account',
    'form.credential.service.label':                         'Service',
    'form.credential.aws.secret.label':                      'Secret access key',
    'form.credential.aws.secret.change.label':               'Change secret access key',
    'form.credential.aws.secret.change.placeholder':         'New secret access key',
    'form.credential.aws.access.label':                      'Access key',
    'form.credential.alicloud.secret.label':                 'Secret access key',
    'form.credential.alicloud.secret.change.label':          'Change secret access key',
    'form.credential.alicloud.secret.change.placeholder':    'New secret access key',
    'form.credential.alicloud.access.label':                 'Access key',
    'form.credential.azure.clientId.label':                  'Application ID',
    'form.credential.azure.clientSecret.label':              'Secret access key',
    'form.credential.azure.clientSecret.change.label':       'Change secret access key',
    'form.credential.azure.clientSecret.change.placeholder': 'New secret access key',
    'form.credential.azure.tenant.label':                    'Directory ID',
    'form.credential.azure.subscription.label':              'Subscription',
    'form.credential.vcloud.username.label':                 'User name',
    'form.credential.vcloud.password.label':                 'Password',
    'form.credential.vcloud.password.change.label':          'Change password',
    'form.credential.vcloud.password.placeholder':           'New password',
    'form.credential.vcloud.host.label':                     'Host',
    'form.credential.vcloud.virtualdatacenter.label':        'Virtual data center',
    'form.credential.vcloud.organization.label':             'Organization',
    'form.credential.submit':                                'Save and stay',

    'spinner.loading':  'Loading...',
    'spinner.updating': 'Updating...',
    'spinner.creating': 'Creating...',
    'spinner.deleting': 'Deleting...',
    'spinner.logout':   'Logging out...',

    // Modals
    'form.terminate.resource': 'Are you sure you want to terminate this resource?',
    'form.terminate.confirm':  'Please, write the resource ID to delete:',
    'form.terminate.success':  'The resource will be terminated',
    'form.terminate.error':    'The ID is incorrect',

    // States
    'label.state.pending':    'Pending',
    'label.state.running':    'Running',
    'label.state.stopped':    'Stopped',
    'label.state.terminated': 'Terminated',
    'label.state.warning':    'Warning',
    'label.state.unknown':    'Unknown',

    // Fixes
    'btn.remove_credential':         'Remove credential',
    'form.modal.credentials.close':  "No, don't do it",
    'form.modal.credentials.remove': 'Yes, remove the credential',
    'label.reservations.ec2':        'Elastic Compute Cloud',
    'form.modal.remove.message':     'Are you sure you want to remove the following credential?',

    'title.error.authorization':    'Authorization error',
    'label.error.authorization':    'Sorry, you don\'t have permissions to perform this task.',
    'label.noDataMessage':          'Sorry, there is no data',
    'label.noDataAvailableMessage': 'Real time information not available for events opened before 2 months.',

    //Datepicker
    'label.datepicker.changetime': 'Change to time',
    'label.datepicker.changedate': 'Change to date',
    'label.datepicker.clear':      'Clear date',
    'label.timepicker.clear':      'Clear time',
    'label.msg_no_date':           'No date',
    'label.msg_no_time':           'No time',
    'btn.ok':                      'Ok',
    'btn.rangedate.changestart':   'Change to start date',
    'btn.rangedate.changeend':     'Change to end date',
    'template.rangedate':          '##start## - ##end##',

    // Resources mobile
    'label.resources.mobile.sortBy':       'Sort by',
    'label.resources.mobile.instanceName': 'Instance name',
    'label.resources.mobile.vendor':       'Vendor',
    'label.resources.mobile.region':       'Region',
    'label.resources.mobile.instanceType': 'Instance type',
    'label.resources.mobile.showCPULoad':  'Show CPU Load',
    'label.resources.mobile.hideCPULoad':  'Hide CPU Load',

    // Backups
    'backups.top10host.title':                         'Top 10 policies per backup consumption',
    'backups.selectHosts.loading':                     'Loading policies...',
    'backups.selectHosts.placeholder':                 'Select policies',
    'backups.selectHosts.header':                      'Available policies',
    'backups.currentMonthPeak':                        'Current month\'s consumption (TB protected)',
    'backups.previousMonthPeak':                       'Previous month\'s consumption (TB protected)',
    'backups.previousMonthPercent':                    'Difference from the previous month',
    'backups.nextEstimation':                          'Next month estimation',
    'backups.daily.overall':                           'Overall',
    'backups.daily.peak':                              'Peak',
    'backups.monthChange':                             'Change since last month',
    'title.backups.mock':                              'Backups mock',
    'title.report':                                    'Details',
    'label.backups.host':                              'Policy',
    'label.backups.period':                            'Start date (UTC)',
    'label.backups.periodEnd':                         'End date (UTC)',
    'label.backups.duration':                          'Duration',
    'label.backups.size':                              'Size',
    'label.backups.type':                              'Type',
    'label.backups.type.FULL':                         'Full',
    'label.backups.type.INCREMENTAL':                  'Incremental',
    'label.backups.type.DIFFERENTIAL':                 'Differential',
    'label.backups.type.ANY_LEVEL':                    'Any level',
    'label.backups.type.SYNTHETICFULL':                'Fully synthetic',
    'label.backups.type.TRANS_LOG_NO_TRUNC':           'Trans log no trunc',
    'label.backups.type.ASR':                          'ASR',
    'label.backups.type.OFFLINE_FULL':                 'Fully offline',
    'label.backups.type.CREATE_SNAPSHOT':              'Create snapshot',
    'label.backups.type.REPLICATE_CREATE':             'Replicate creation',
    'label.backups.type.REPLICATE_INCREMENTAL_UPDATE': 'Replicate incremental update',
    'label.backups.type.ONLINE_FULL':                  'Online full',
    'label.backups.type.UNKNOWN':                      'Unknown',
    'label.backups.info':                              'Info',
    'label.backups.status':                            'Status',
    'label.backups.status.FAILED':                     'Failed',
    'label.backups.status.STARTFAILED':                'Failed to start',
    'label.backups.status.KILLED':                     'Killed',
    'label.backups.status.PARTIALSUCCESS':             'Partial success',
    'label.backups.status.SUCCESS':                    'Success',
    'label.backups.status.UNKNOWN':                    'Unknown',
    'label.backups.article':                           'Service type',
    'label.backupsMachines.vcenter':                   'VCENTER',
    'label.backupsMachines.vmachine':                  'VM',
    'label.backupsMachines.startDate':                 'Start date',
    'label.backupsMachines.endDate':                   'End date',
    'label.backupsMachines.duration':                  'Duration',
    'label.backupsMachines.size':                      'Size (Gb)',
    'template.backups.dates':                          'At ##start## (##duration##)',
    'placeholder.search_backups':                      'Policy...',
    'btn.exportCSV':                                   'Download',
    'backups.contract':                                'Contract',
    'backups.hostData':                                'Host Data',
    'backups.labelValue':                              'Total size',
    'backups.top.ten.host.title':                      'Top 10 backups',
    'backups.last13months.chart':                      'Backup consumption in last months (max 13)',
    'backups.last13months.months':                     'Months',
    'extra.information.backups':                       'A policy can contain more than one device. If you have any questions, please contact your project manager.',

    'legend.text.all':         'Show All',
    'legend.text.reset':       'Reset',
    'legend.text.none':        'Hide All',
    'legend.text.placeholder': 'Filter by',
    'legend.text.header':      'Applied filters',

    'label.mobile.sortBy': 'Sort by',

    'status.widget.vendor': 'Vendor',
    'btn.reset.zoom':       'Reset zoom',
    'status.widget.status': 'Status',

    //Errors
    'error.VM_NOT_FOUND':               'You don\'t have permissions to see this Vm or the Vm doesn\'t exist.',
    'error.VENDOR_NOT_MATCH':           'This vendor can\'t get CPU usage.',
    'error.INCIDENT_NOT_FOUND':         'You don\'t have permissions to see an incident or the incident doesn\'t exist.',
    'error.SERVICE_OFFERING_NOT_FOUND': 'You don\'t have permissions to see a service offering or the service offering doesn\'t exist.',
    'error.STATE_NOT_FOUND':            'You don\'t have permissions to see a state or the state doesn\'t exist.',
    'error.MISSING_CREDENTIALS':        'You don\'t have credentials for this service.',
    'error.PERMISSION_DENIED':          'You don\'t have permissions for this service.',
    'error.INVALID_PAYLOAD':            'The sent data is wrong.',
    'error.VENDOR_NOT_FOUND':           'This vendor can\'t get cpu usage.',
    'error.INVALID_CREDENTIALS':        'Invalid credential for this service.',
    'error.ITEM_NOT_FOUND':             'Item not found.',
    'error.INTERNAL_SERVER_ERROR':      'There was an internal server error.',
    'error.SERVICE_UNAVAILABLE':        'This service is unavailable.',
    'error.FORBIDDEN':                  'You have not permission to permorf this task.',
    'error.INVALID_ACCOUNT':            'The account format is not valid.',
    'error.chunk.title':                'Error',
    'error.chunk.text':                 'There was a problem loading this view. Please, press Ctrl+F5 to try to solve this.',

    'label.resources.msp.false': 'No',
    'label.resources.msp.true':  'Yes',

    'label.notifications.removeall': 'Dismiss all',

    'label.filters.mobile.hideButton':  'Hide filters',
    'label.filters.mobile.showFilters': 'Show filters',
    'label.filters.filtering.message':  'Applying filters (show)',

    'label.sorted.field.desc': 'Sorted by {sortFieldName} in a descending way',
    'label.sorted.field.asc':  'Sorted by {sortFieldName} in an ascending way ',

    // Vendor
    'label.gcp':       'Google Cloud Platform',
    'label.gcloud':    'Google Cloud Platform',
    'label.aws':       'Amazon Web Services',
    'label.azure_csp': 'Microsoft Azure',
    'label.vcloud':    'Vcloud',
    'label.itconic':   'Itconic',
    'label.oracle':    'Oracle Cloud',
    'label.alicloud':  'Alibaba Cloud',

    'title.page.alert':  '{alerts} new alert - {title}',
    'title.page.alerts': '{alerts} new alerts - {title}',

    'form.aws_support.account.label':                     'Account',
    'form.aws_support.subject.label':                     'Subject',
    'form.aws_support.service.label':                     'Service',
    'form.aws_support.category.label':                    'Category',
    'form.aws_support.severity.label':                    'Severity',
    'form.aws_support.description.label':                 'Description',
    'form.aws_support.cc.label':                          'Email list',
    'form.attachments.button':                            'Attach files',
    'form.aws_support.attachments.label':                 'Attachment',
    'form.aws_support.attachments.success':               'The {filesCount, plural, one {file} other {files}} {fileNames} {filesCount, plural, one {was} other {were}} uploaded successfuly.',
    'form.aws_support.attachments.max_files':             'You are trying to attach {chosen} files but just {max} is allowed',
    'form.aws_support.attachments.max_size':              'You are trying to attach {name} that have {size} but max allowed is {max}',
    'form.aws_support.attachments.already':               'You are trying to attach {name} that was already chosen',
    'form.aws_support.comment.label':                     'Comment',
    'form.aws_support.comment.error.is_required':         'Please enter a comment',
    'placeholder.search_aws_support':                     'Case ID (only one)',
    'placeholder.aws_support.account':                    'Select the account to show its tickets.',
    'label.resolved.on':                                  'Resolved',
    'label.resolved.off':                                 'Not resolved',
    'label.aws.created':                                  'Created',
    'label.aws.subject':                                  'Subject',
    'label.aws.id':                                       'Ticket',
    'label.aws.severity':                                 'Severity',
    'label.aws.status':                                   'Status',
    'label.aws.attachments':                              'Attachments',
    'label.aws.description':                              'Description',
    'label.aws.service':                                  'Service',
    'label.aws.category':                                 'Category',
    'label.aws.cc':                                       'CC',
    'label.all_status':                                   'Any status',
    'label.status':                                       'Status',
    'label.aws.comment':                                  'Add a comment',
    'form.ticket.submit':                                 'Save and stay',
    'label.aws_support_status.unassigned':                'Unassigned',
    'label.aws_support_status.opened':                    'Opened',
    'label.aws_support_status.reopened':                  'Reopened',
    'label.aws_support_status.work-in-progress':          'Work in progress',
    'label.aws_support_status.pending-customer-action':   'Pending customer action',
    'label.aws_support_status.customer-action-completed': 'Customer action completed',
    'label.aws_support_status.resolved':                  'Resolved',
    'label.aws_support_severity.low':                     'Low',
    'label.aws_support_severity.normal':                  'Normal',
    'label.aws_support_severity.high':                    'High',
    'label.aws_support_severity.urgent':                  'Urgent',
    'btn.add_support':                                    'Add ticket',
    'btn.close_support':                                  'Close ticket',
    'btn.aws_support.showMore':                           'Show more',
    'btn.aws_support.init':                               'Init page',
    'template.aws_support.created':                       'Created by {account} ({accountId}) {date}',

    'label.aws_support.type.billing':   'Billing',
    'label.aws_support.type.technical': 'Technical',

    'title.alert.accounts':                     'Accounts',
    'title.alert.awsAccounts':                  'AWS accounts',
    'title.alert.awsCredentials':               'AWS credentials',
    'title.alert.awsInstanceTypes':             'AWS instance types',
    'title.alert.awsProducts':                  'AWS products',
    'title.alert.awsRegions':                   'AWS regions',
    'title.alert.awsSupport':                   'AWS support',
    'title.alert.awsSupportBilling':            'AWS support billing',
    'title.alert.awsSupportTechnical':          'AWS suport technical',
    'title.alert.azrProducts':                  'Azure products',
    'title.alert.azrRegions':                   'Azure regions',
    'title.alert.azureAccounts':                'Azure accounts',
    'title.alert.azureCredentials':             'Azure credentials',
    'title.alert.backupsDaily':                 'Backups daily',
    'title.alert.backupsHosts':                 'Backups hosts',
    'title.alert.categoriesAwsSupport':         'AWS Support categories',
    'title.alert.googleAccounts':               'Google accounts',
    'title.alert.issues':                       'Incidents',
    'title.alert.issuesByState':                'Incidents',
    'title.alert.issueStatuses':                'Status',
    'title.alert.internetMonthly':              'Internet traffic monthly',
    'title.alert.internetDaily':                'Internet traffic daily',
    'title.alert.itcProducts':                  'Itconic products',
    'title.alert.itcRegions':                   'Itconic regions',
    'title.alert.operationLogs':                'Operation logs',
    'title.alert.regions':                      'Regions',
    'title.alert.reportBackups':                'Report backups',
    'title.alert.reportingBackupsHost':         'Reporting backups hosts',
    'title.alert.reportingLast2MonthsBackups':  'Last 2 months backups',
    'title.alert.reportingLast13MonthsBackups': 'Last 13 months backups',
    'title.alert.reports':                      'Billing',
    'title.alert.reservations':                 'Reservations',
    'title.alert.resources':                    'Resources',
    'title.alert.resourceTypes':                'Resource types',
    'title.alert.securityCredentials':          'Security credentials',
    'title.alert.services':                     'Services',
    'title.alert.servicesAwsSupportBilling':    'AWS support billing services',
    'title.alert.servicesAwsSupportTechnical':  'AWS support technical services',
    'title.alert.servicesOffering':             'Service offering',
    'title.alert.severities':                   'Severities',
    'title.alert.spendingByAccount':            'Spending by account',
    'title.alert.spendingByCostCenter':         'Spending by project',
    'title.alert.spendingByProductArea':        'Spending by product area',
    'title.alert.spendingByVendor':             'Spending by vendor',
    'title.alert.spendingLastYear':             'Spending last year',
    'title.alert.subscriptions':                'Subscriptions',
    'title.alert.tasksState':                   'Task states',
    'title.alert.tasksTypes':                   'Task types',
    'title.alert.topByAccount':                 'Top by account',
    'title.alert.topByCostCenter':              'Top by project',
    'title.alert.topByProductArea':             'Top by product area',
    'title.alert.totalSpending':                'Total spending',
    'title.alert.vcloudAccounts':               'Vcloud accounts',
    'title.alert.vcloudCredentials':            'Vcloud credentials',
    'title.alert.vendors':                      'Vendors',
    'title.alert.vmStates':                     'VM states',
    'title.alert.iaasVirtualMachines':          'Virtual Machines',
    'title.alert.alicloudAccounts':             'Alicloud accounts',

    'label.currentMonth': 'Current month',

    'form.password.button':     '(Change)',
    'form.password.save':       'Save',
    'form.password.old.label':  'Old password',
    'form.password.new1.label': 'New password',
    'form.password.new2.label': 'Repeat new password',
    'form.password.title':      'Change password',
    'form.password.success':    'Password changed correctly',

    'message.noConsume': 'We are sorry. There aren\'t any reports available yet',

    'updated.title':                'Updated app',
    'updated.ok':                   'Accept',
    'update.ok.accept':             'Accept and close',
    'updated.text':                 'The app has been updated. It\'s going to be reloaded to get this update.',
    'label.button.showDescription': 'Show description',
    'label.button.hideDescription': 'Hide description',
    'label.description':            'Description',

    'add.serviceNowUsers': 'Add users to follow the incident',

    // BUTTON States
    'issues.button.reactive':           'Reactive incident',
    'issues.button.reopen':             'Reopen incident',
    'issues.button.cancel':             'Cancel incident',
    'issues.button.cancelDisable':      'Please, write a description to cancel the incident',
    'issues.button.comment':            'Comment',
    'issues.cancelmodal.title':         'Cancel issue',
    'request.cancelmodal.title':        'Cancel request',
    'issues.cancelmodal.body':          'Are you sure do you want to cancel the issue ##issue##?',
    'issues.cancelmodal.button.accept': 'Yes, cancel issue',
    'issues.cancelmodal.button.cancel': "No, don't do it",

    // Button Actions
    'button.next':                'Next',
    'button.back':                'Back',
    'button.securityCredentials': 'My security credentials',

    // Containers service now
    'label.requesters.label':                            'Name',
    'label.requesters.id':                               'ID',
    'label.serviceOffering.label':                       'Service',
    'label.serviceOffering.id':                          'ID',
    'label.companyColumn.label':                         'Company name',
    'label.companyTitle':                                'Select the company',
    'label.company.selected.title':                      'Selected company',
    'button.cancel':                                     'Cancel',
    'button.accept':                                     'Accept',
    'form.issue.impact.default':                         'No loss of service',
    'form.request.urgency.default':                      'Low',
    'label.watchList.comment.placeholder':               'Add an email',
    'label.watchList.search':                            'Click to search an user',
    'placeholder.searchServiceNowUser':                  'Search by user name',
    'placeholder.searchByServiceOffering':               'Search by service offering name',
    'placeholder.searchServiceNowCompany':               'Search by company name',
    'label.optional.field':                              'optional',
    'label.watchlist.users':                             'Watch list users',
    'form.issue.service_offering.modal.serviceOffering': 'Selected service offering',
    'label.issues.attachments':                          'Attached files',
    'label.issues.attachFiles':                          'Attach files',
    'label.button.cancel':                               'Cancel',

    'label.choose.files':           'Attach file',
    'label.uploadState.error':      'There was an error. Please, try it again.',
    'label.uploadState.processing': 'Processing',
    'label.uploadState.finished':   'Finished',
    'label.uploadState.inProgress': 'Done',
    'label.uploadState.pending':    'Pending to start',

    'label.watchList.nousers': 'There are not users in the watch list',

    'label.date.prep':                       'on',
    'label.noAttachedFiles':                 'No files attached',
    'label.issue.totalAttachments.plural':   'There are {number} attachments',
    'label.issue.totalAttachments.singular': 'There is {number} attachment',
    'label.showMore':                        'SHOW MORE',
    'label.showLess':                        'SHOW LESS',

    'label.noCustomerTicketIssue': 'None',

    'table.issues.customerActionNeeded': 'Customer action needed',

    'label.issues.state.open':                 'Open',
    'label.issues.state.pending':              'Pending',
    'label.issues.state.resolved':             'Resolved',
    'label.issues.state.closed':               'Closed',
    'label.issues.state.customerActionNeeded': 'Customer action needed',
    'label.issues.customerActionNeeded.help':  'Show customer action needed tickets',

    'label.issues.state.open.plural':                 'Open',
    'label.issues.state.pending.plural':              'Pending',
    'label.issues.state.resolved.plural':             'Resolved',
    'label.issues.state.closed.plural':               'Closed',
    'label.issues.state.customerActionNeeded.plural': 'Customer action needed',

    'label.requests.state.open':                 'Open',
    'label.requests.state.pending':              'Pending',
    'label.requests.state.resolved':             'Delivered',
    'label.requests.state.closed':               'Closed',
    'label.requests.state.customerActionNeeded': 'Customer action needed',
    'label.requests.customerActionNeeded.help':  'Show customer action needed tickets',

    'label.requests.state.open.plural':                 'Open',
    'label.requests.state.pending.plural':              'Pending',
    'label.requests.state.resolved.plural':             'Delivered',
    'label.requests.state.closed.plural':               'Closed',
    'label.requests.state.customerActionNeeded.plural': 'Customer action needed',

    'label.watchList.help':         'If you would like to share the activity of this incident please add an email or click on the button to add users from your company',
    'label.watchList.help.request': 'If you would like to share the activity of this request please add an email or click on the button to add users from your company',
    'title.alert.attachments':      'Error uploading file',

    //P200
    'title.p200':         'Monthly Report',
    'title.p200.report':  'Reports',
    'table.col.id':       '#',
    'table.col.filename': 'Report',
    'table.col.size':     'Size',

    // Request
    'title.requests':                'Requests',
    'btn.add_request':               'New request',
    'label.request.approval':        'Approval',
    'label.request.item':            'Requested item',
    'label.request.urgency':         'Urgency',
    'label.request.state.pending':   'Pending',
    'label.request.state.open':      'Open',
    'label.request.state.in-course': 'In course',
    'label.request.state.delivered': 'Delivered',
    'label.request.state.closed':    'Closed',
    'request.button.cancel':         'Cancel Request',
    'request.button.cancelDisable':  'Please, write a description to cancel the request',
    'request.button.comment':        'Comment',
    'request.button.reactive':       'Reactive request',
    'request.button.reopen':         'Reopen request',
    'request.catalog.category':      'Categories',
    'request.catalog.items':         'Items',
    'generic.error':                 'We are sorry, there was an error',

    'form.request.urgency.label':       'Urgency',
    'form.request.urgency.placeholder': 'Select the urgency of the request',

    'cookie.accept':       'Accept cookies',
    'cookie.moreInfo':     'More information',
    'cookie.message':      'We only use own and third party cookies, for session purposes, with technical finalities (those that allow the user to navigate through the website and use the different options and services that exist in it).',
    'title.alert.request': 'Error in the requests',
    'title.catalog':       'Available catalogs',

    // Alerts
    'title.alert.requests':        'Requests',
    'title.alert.reportsP200':     'Monthly report',
    'title.alert.internetClient':  'Internet access',
    'title.alert.requestCatalog':  'Catalog',
    'title.alert.requestsByState': 'Requests',
    'title.alert.requestItem':     'Requests',
    'title.alert.requestCategory': 'Requests',
    'error.undefined':             'There was an error. Please try late',

    'requestCatalogError.title':  'Sorry, there was an error in our servers',
    'requestCatalogError.button': 'Click here to try again or wait a few seconds',

    // ERRORS
    DEFAULT_ERROR_MESSAGE: 'Please check the form fields',
    BAD_REQUEST:           'The request is not valid',
    DUPLICATE_ACCOUNT:     'The selected account already exist',
    INVALID_PASSPHRASE:    'The selected passphrase is not correct',
    INVALID_FORMAT:        'The format for this field is not valid',
    INTERNAL_SERVER_ERROR: 'Sorry, there was an error in our servers',
    PERMISSION_DENIED:     'You does not have permissions to do this action',
    VALIDATION_ERROR:      'Sorry, there was a validation error. Please check the fields of the form',
    DUPLICATE_SERVICE:     'The selected service already has an assigned credential',
    PRIVATE_KEY_IS_EMPTY:  'Please, the private key field cannot be empty',

    'form.credentials.help':                   'Do you need help to get your credentials?',
    'button.copyToClipboard':                  'Copy to clipboard',
    'help.credentials.awsServices.firstStep':  'To get your access key and your secret key, please, visit this link',
    'help.credentials.awsServices.secondStep': ' To add the policy, copy the next policy or click on "Copy to clipboard" button and,\n' +
    'to set it on AWS visit this ',

    'placeholder.requests.status': 'Status',

    // ORACLE ACCOUNTS
    'title.alert.credential':                         'Credentials',
    'title.alert.account':                            'Accounts',
    'title.alert.oracleCredentials':                  'Oracle credentials',
    'form.credentials.created.success':               'The credential has been created',
    'form.credentials.modified.success':              'The credential has been edited',
    'form.credentials.deleted.success':               'The credential has been deleted',
    'form.credentials.created.error':                 'The credential has not been created',
    'form.credentials.modified.error':                'The credential has not been edited',
    'form.credentials.deleted.error':                 'The credential has not been deleted',
    'form.account.edited.error':                      'The account has not been edited',
    'form.account.edited.success':                    'The account has been edited',
    'form.credential.oracle.help.link':               'If you need help, please visit this link: ',
    'form.credential.oracle.help.doc':                'Oficial Oracle documentation',
    'form.credential.oracle.userOcid.label':          'User OCID',
    'form.credential.oracle.userOcid.placeholder':    'Oracle Cloud Identifier of the user',
    'form.credential.oracle.tenancyOcid.label':       'Tenancy OCID',
    'form.credential.oracle.tenancyOcid.placeholder': 'Oracle Cloud Idenfifier of the tenancy',
    'form.credential.oracle.privateKey.label':        'Private key for the user',
    'form.credential.oracle.privateKey.change.label': 'Change private key',
    'form.credential.oracle.passphrase.label':        'Passphrase (optional)',
    'form.credential.oracle.fingerprint.label':       'Fingerprint',
    'form.credential.oracle.uploadFile.label':        'Select private key file',
    'form.credential.oracle.privatekey.placeholder':  'Change the private key',
    'form.credential.oracle.passphrase.help':         'The passphrase for the public/private key pair, if you specified one when creating the key pair.',

    BACKUP_CONSULT_SESSIONS:          'Backup consult sessions',
    PROTECTED_BACKUP:                 'Protected backup',
    CMS_BACKUP_MONTHLY_CONSUMPTION:   'CMS backup monthly consumption',
    CMS_IAAS_MONTHLY_CONSUMPTION:     'CMS IAAS montly consumption',
    IAAS_MACHINE_ACTIVITY:            'IAAS machine activity',
    IAAS_CONSUMPTION_DETAIL:          'IAAS consuption detail',
    MONITORING_EVENTS:                'Monitoring events',
    KECT_QUALITY_RESOLUTION:          'KECT quality resolution',
    CKET_REOPENED:                    'CKET reopened',
    CKET_RESOLUTION_TIME:             'CKET resolution',
    CKET_RESPONSE_TIME:               'CKET response time',
    KECT_VOLUMETRY_BY_CATEGORIZATION: 'KECT volumetry by categorization',

    'title.link':                             'link',
    'cell.service.discovery':                 'service discovery',
    'cell.service.start-stop':                'start/stop resources',
    'cell.service.support':                   'support',
    'cell.service.aws-support':               'AWS support',
    'cell.edit':                              'Edit credentials for this service:',
    'cell.create':                            'Create credentials for this service:',
    'cell.disable':                           'is not available for this vendor',
    'title.alert.success.discovery.accounts': 'Starting discovery process',
    'title.alert.warning.discovery.accounts': 'There was a problem starting process to discover resources',
    discoverSuccess:                          'Discovering the next accounts: ',
    discoverWarning:                          'Next accounts do not have credentials for the discover service',
    'discover.addCredential.title':           'Click here to add Service Discovery credential for this account',
    'support.button':                         'Support',

    'service-discovery':       'Service discovery',
    'aws-support':             'AWS support',
    'start-stop-vm':           'Start/Stop VM',
    'title.service-discovery': 'Service discovery',
    //'start-stop-vm':         'Start-Stop',
    support:                   'Support',

    // Credentials Cards
    'card.has.credential': 'You already have a credential for this account',

    'title.billing_alerts':             'Billing Alerts',
    'title.billing_alert':              'Billing alert',
    'title.alert.alert':                'Billing alerts',
    'title.billing_alerts.new':         'New billing alert',
    'label.billingAlerts.mode':         'Mode',
    'label.billingAlerts.name':         'Alert name',
    'label.billingAlerts.type':         'Type',
    'label.billingAlerts.entities':     'Item',
    'label.billingAlerts.amount':       'Amount in USD',
    'label.billingAlerts.state':        'State',
    'label.billingAlerts.active':       'Active',
    'label.billingAlerts.active.form':  'Do you want to create the alert enabled?',
    'label.billingAlerts.title':        'Alert',
    'label.billingAlerts.emails':       'CC',
    'label.billingAlerts.lastRun':      'Last check',
    'label.billingAlerts.modeHelpBulk': 'Choose bulk mode if you want to create one alert for every selected item',
    'label.billingAlerts.modeHelpSum':  'Choose sum mode if you want to create one alert for a sum of items ',

    'label.billingAlerts.name.placeholder':     'The alert name',
    'label.billingAlerts.type.placeholder':     'Type of alert',
    'label.billingAlerts.entities.placeholder': 'Item of the alert',
    'label.billingAlerts.amount.placeholder':   'The maximum amount for the alert',
    'label.billingAlerts.active.placeholder':   'Enabled alert',
    'label.billingAlerts.emails.placeholder':   'Emails to send the alert',
    'label.billingAlerts.remove.modal.title':   'Remove billing alerts',
    'label.billingAlerts.remove.modal.message': 'Are you sure you want to remove the following billing alerts?',
    'label.billingAlerts.remove.modal.accept':  'Yes, remove the billing alerts',
    'btn.add_billingAlert':                     'Add billing alert',
    'btn.alerts.delete':                        'Remove billing alert',
    'placeholder.billingAlerts.search':         'Alert name, item name...',
    'label.allStates':                          'State',
    'label.type':                               'Type',
    'form.alert.created.success':               'The alert has been created succesfully',
    'form.alert.updated.success':               'The alert has been updated succesfully',
    'form.alert.delete.success':                'The alert has been deleted succesfully',
    'form.alert.created.error':                 'The alert has not been created',
    'form.alert.updated.error':                 'The alert has not been updated',
    'form.alert.deleted.error':                 'The alert has not been deleted',
    'title.alert':                              'Billing alerts',

    'billingAlerts.entityType.accounts': 'Accounts',
    'billingAlerts.entityType.projects': 'Projects',
    'billingAlerts.entityType.vendors':  'Vendors',

    'billingAlerts.state.disabled': 'Disabled',
    'billingAlerts.state.pending':  'Pending',
    'billingAlerts.state.ok':       'OK',
    'billingAlerts.state.warning':  'Warning',
    'billingAlerts.state.reached':  'Reached',
    cannontBeEmpty:                 'Please, choose at least one item',

    'form.billingAlerts.entities.modal.accounts': 'Accounts',
    'form.billingAlerts.entities.modal.projects': 'Projects',
    'form.billingAlerts.entities.modal.vendors':  'Vendors',

    'form.modal.billingAlerts.close':   "No, don't do it",
    'form.modal.billingAlerts.remove':  'Yes, remove the billing alert',
    'form.modal.billingAlerts.message': 'Are you sure you want to remove the billing alert?',

    'title.alert.billingAlertsTypes':  'Billing alerts types',
    'title.alert.billingAlertsStates': 'Billing alerts states',
    'title.alert.billingAlerts':       'Billing alerts',

    IS_EMPTY:                   'This field cannot be empty',
    'title.billingAlertsTypes': 'Billing alerts',

    NOT_ALLOWED_ACCOUNT: 'We are sorry. This account cannot perform this action',
    INVALID_PAYLOAD:     'We are sorry. Tere was a validation error. Please check the fields of the form',

    description:   'Description',
    attachments:   'Attachments',
    category_code: 'Category',
    cc:            'Emails',
    severity_code: 'Severity',
    subject:       'Subject',
    service:       'Service',
    category:      'Category',
    account_id:    'Account',

    'url.cookieConsent': 'https://www.equinix.com/company/legal/privacy/',

    'btn.stopResource':               'Stop resource',
    'form.modal.resource.stop':       'Yes, I want to stop this resource',
    'btn.startResource':              'Start resource',
    'form.modal.resource.start':      'Yes, I want to start this resource',
    'btn.stopResource.list':          'Stop the following resources:',
    'form.modal.resource.stop.list':  'Yes, I want to stop the following resources',
    'btn.startResource.list':         'Start the following resources:',
    'form.modal.resource.start.list': 'Yes, I want to start the following resources',

    'title.alert.oracleAccounts':     'Oracle accounts',
    'title.alert.awsSupportComments': 'Amazon Web Services support',

    'label.amount':              'Amount:',
    'form.alerts.label.help':    'You can add more than one email separating them by hitting Enter, comma, space or tab keys',
    mandatoryCookiesLabel:       'Mandatory cookies',
    googleAnalyticsLabel:        'Google analytics',
    googleAnalyticsDescription:  'Data collection necessary for the user to improve the performance of the application',
    mandatoryCookiesDescription: 'Necessary cookies for an optimizated experience in the aplication',

    'form.credential.google.credentialsFile.placeholder':      'Service account keys',
    'form.credential.google.credentialsFile.placeholder.new':  'Attach file with service account keys',
    'form.credential.google.credentialsFile.placeholder.edit': 'Change file of the service account keys',
    'form.credential.google.credentialsFile.label':            'Service account keys',
    'form.credential.google.credentialsFile.change.label':     'Change file of the service account keys',
    'form.credential.help.link':                               'If you need help creating your credentials, visit the following link: ',
    'form.credential.help.website':                            'Cloudglass blog',
    'form.credential.google.currentCredentials':               'Current service account keys: ',
    'title.alert.googleCredentials':                           'Google credentials',
    'title.google.handlePermissions':                          'Check permissions',
    'label.accept':                                            'Accept',
    'label.checkbox.notShowAgain':                             'Do not show this message again',
    'label.newFeatures.message':                               'We have updated Cloudglass with the following features',
    'title.managePermissions':                                 'Manage cookies permissions',
    'title.modifyCredentials':                                 'Modify credentials',
    'title.editCredentials':                                   'Edit credentials',
    'form.billingAlerts.cc.label':                             'Emails to send the alert',

    'alert.updateData':                         'Last updated',
    'title.ActiveEvents':                       'Active events',
    'title.AllEvents':                          'All events',
    'title.active.closed.events':               'Total active and closed events',
    'title.monitoring':                         'IT monitoring',
    'title.events':                             'Events',
    'title.DetailEvents':                       'Details',
    'label.openEventsBySeverity':               'Open events by severity',
    'label.totalEventsBySeverity':              'Total events by severity',
    'label.top10CIWithActiveEvents':            'Top 10 CI with active events',
    'label.top10CIWithInactiveEvents':          'Top 10 CI with closed events',
    'label.CIByCIClass':                        'Events by CI class',
    'label.CiClass':                            'CI class',
    'label.allCiClass':                         'All CI class avalaible',
    'label.OpenEventsByclass':                  'Open events by class',
    'label.eventsByclass':                      'Events by class',
    'label.top10MonitorClassWithActiveEvents':  'Top 10 Object class with active events',
    'label.top10MonitorClassTotalEvents':       'Top 10 Object class',
    'label.top10MonitorCITotalEvents':          'Top 10 CI',
    'label.top10ObjectClassWithInactiveEvents': 'Top 10 Object class with closed events',
    'label.hourlyPerDaySeverity':               'Daily grouped by severity',
    'label.numberActiveEvents':                 'Active events',
    'label.numberInactiveEvents':               'Closed events',
    'label.numberEvents':                       'Events',
    hour:                                       'Created date',
    closedDate:                                 'Closed date',
    severity:                                   'Severity',
    node:                                       'CI',
    object:                                     'Object',
    objectClass:                                'Object Class',
    operable:                                   'Operated by Equinix',
    'monitoring.allEvents':                     'All events',
    'monitoring.OperatedByEquinixSupport':      'Events operated by Equinix',
    'monitoring.NoOperatedByEquinix':           'Events not operated by Equinix',
    'label.monitoring.operable.false':          'No',
    'label.monitoring.operable.true':           'Yes',
    'field.closedDate':                         'Still open',

    'label.bulkMode':          '{totalAlerts} independent alerts will be created, one for each of the items selected, for a total amount of {amount} each.',
    'label.bulkMode.vendor':   '{totalAlerts} independent alerts will be created, one for each of the vendors selected, for a total amount of {amount} each.',
    'label.bulkMode.accounts': '{totalAlerts} independent alerts will be created, one for each of the accounts selected, for a total amount of {amount} each.',
    'label.bulkMode.projects': '{totalAlerts} independent alerts will be created, one for each of the projects selected, for a total amount of {amount} each.',
    'label.sumMode':           'An alert will be created, which will be triggered when all the items selected reach {amount}.',
    'label.editSumMode':       'The alert will be triggered when the sum of all selected items reach {amount}.',

    'label.sumMode.accounts': 'An alert will be created, which  will be triggered when all the accounts selected  reach  {amount}.',
    'label.sumMode.projects': 'An alert will be created, which  will be triggered when all the projects selected  reach  {amount}.',
    'label.sumMode.vendor':   'An alert will be created, which  will be triggered when all the vendors selected  reach  {amount}.',

    'label.bulkModeModal':        '{totalAlerts} independent alerts will be created for each selected item.',
    'label.sumModeModal':         'An alert will be created, which will be triggered when the sum of all selected items reach the specified amount.',
    'label.modal.selectVendor':   'Select one or more vendors',
    'label.modal.selectAccounts': 'Select one or more accounts',
    'label.modal.selectProjects': 'Select one or more projects',
    'label.modal.select':         'Select one or more items',

    'form.saveAndBack': 'Save',

    'label.selectAlerts': 'Select alerts',

    'table.consolidateLastRun.name':    'Name',
    'table.consolidateLastRun.lastRun': 'Updated',
    'title.alert.consolidateLastRun':   'Last update',
    'btn.showDetails':                  'Show details',
    'btn.backToTotals':                 'Back to totals',

    // CLOUD BILLING
    'label.difference':    '{selected} vs {prev}',
    'label.previousMonth': 'Previous month',

    'title.alert.cloudBillingProjects': 'Projects',
    'title.alert.cloudBillingServices': 'Services',
    'title.alert.cloudBillingAccounts': 'Accounts',
    'title.alert.cloudBillingVendors':  'Vendors',
    'title.alert.cloudBillingRegions':  'Regions',

    'title.alert.costCenters': 'Projects',
    'title.alert.tenant':      'Tenant',

    'title.accountsToDiscover': 'Select accounts to discover',

    'title.portals':       'Managed Services',
    'title.tenant.alert':  'Tenant',
    'label.otherPortals':  'Other portals',
    'label.customerVoice': 'Customer Voice',
    'label.quickLinks':    'Quick Links',
    'label.logginTenant':  'Loggin in: ',

    accounts: 'Accounts',
    projects: 'Projects',
    services: 'Services',
    regions:  'Regions',
    vendors:  'Vendors',

    entityDetail: 'Detail',

    account:           'Account',
    vendor:            'Vendor',
    region:            'Region',
    project:           'Project',
    product:           'Service',
    cost_center:       'Project',
    monthlySpending:   'Current Month',
    previousSpending:  'Previous Month',
    percent:           'Percent',
    selectionSpending: 'Selection spending: ',
    selectionResume:   'Selection',

    accountSingular: 'account',
    accountPlural:   'accounts',
    vendorSingular:  'vendor',
    vendorPlural:    'vendors',
    regionSingular:  'region',
    regionPlural:    'regions',
    projectSingular: 'project',
    projectPlural:   'projects',
    serviceSingular: 'service',
    servicePlural:   'services',
    entity:          'Item',

    labelSelectedEntities:   'There are {selected} items selected ({total} in total)',
    labelSelectedEntities2:  'There are {selected} items selected. {total} in total.',
    labelSelectAllEntities:  'Select {select} items',
    entityTableTitle:        'How much is the spending of my {selected}?',
    subEntityTableTitle:     'What {subEntitySelected} bellong to my {selected}?',
    selectedTableMessage:    'The selected items has spent {amount} on {selectedMonth}',
    allPageEntitiesSelected: 'All page items are selected',
    noEntitiesSelected:      'There are no items selected',
    createAlertFor:          'Create alert for the item: ',

    thereAre:            'There are ',
    selectedEntities:    ' selected items',
    select2:             'Select',
    entities:            'items',
    allEntitiesSelected: 'All items are selected',
    inTotal:             'in total',

    cloudBillingBreakdownButton: 'Breakdown',
    cloudBillingExportButton:    'Download',
    cloudBillingCreateAlert:     'Create alert',

    placeholderEntitySearch: 'Search...',
    showSelected:            'Show selection',
    showSelectedTooltip:     'Click to show only the selected entities',
    showBreakdown:           'Show selection breakdown',
    showAllEntities:         'Show all items',

    select:               'Select items',
    selectAllEntities:    'Select all items',
    selectPageEntities:   'Select all page items',
    unselectPageEntities: 'Unselect all page items',
    unselectAllEntities:  'Unselect all items',
    leaveSelected:        'Show all',

    chartWidgetTitle:  'Total spending',
    dailyChartTitle:   'Daily',
    monthlyChartTitle: 'Annual',
    last12MonthsTitle: 'Last 12 months',
    yearToDateTitle:   'YTD',
    yearToDateTooltip: 'Year to date',

    chartMainTitleDaily:        'Daily spent selection',
    chartMainTitleYTD:          'Year to date spent selection',
    chartMainTitleLast12Months: 'Last 12 months spent selection',
    chartMainTitleAnnual:       'Year spent selection',

    labelSelectedAccounts: 'There are {selected} accounts selected ({total} in total)',
    labelSelectedVendors:  'There are {selected} vendors selected ({total} in total)',
    labelSelectedRegions:  'There are {selected} regions selected ({total} in total)',
    labelSelectedProjects: 'There are {selected} projects selected ({total} in total)',

    labelUnlock:            'This bookmark is saved. Click to remove bookmark.',
    labelLock:              'Save this bookmark',
    'label.bookmark':       'bookmark',
    editBookmarkName:       'Edit name',
    'label.bookmark.empty': 'There is no bookmark created. To add one, select the items you want it to contain and press the button with the icon "',

    percentDifference:       'than previous month',
    createAlert:             'Create alert',
    cloudBillingTitleResume: 'Explorer',
    spendingBreakdown:       'Breakdown',
    totalSpending:           'Selection spending',

    projectsSelectedSpending: 'Selected projects have spent {amount} on {selectedMonth}',
    accountsSelectedSpending: 'Selected accounts have spent {amount} on {selectedMonth}',
    vendorsSelectedSpending:  'Selected vendors have spent {amount} on {selectedMonth}',
    servicesSelectedSpending: 'Selected services have spent {amount} on {selectedMonth}',
    regionsSelectedSpending:  'Selected regions have spent {amount} on {selectedMonth}',
    defaulTitleSpendingError: 'We are sorry, there was an error',

    projectsSelectedTableTitle: 'My projects expenses',
    accountsSelectedTableTitle: 'My accounts expenses',
    servicesSelectedTableTitle: 'My services expenses',
    vendorsSelectedTableTitle:  'My vendors expenses',
    regionsSelectedTableTitle:  'My regions expenses',

    subEntityTitle: 'Which {subEntity} belong to my {entity}?',

    projectTitle: 'projects',
    regionTitle:  'regions',
    serviceTitle: 'services',
    vendorTitle:  'vendors',
    accountTitle: 'accounts',

    labelResumeSelectedAccounts:           'There are {selected} selected accounts ({total} in total)',
    labelResumeSelectedProjects:           'There are {selected} selected projects ({total} in total)',
    labelResumeSelectedRegions:            'There are {selected} selected regions ({total} in total)',
    labelResumeSelectedVendors:            'There are {selected} selected vendors ({total} in total)',
    labelResumeSelectedServices:           'There are {selected} selected services ({total} in total)',
    'label.cloudBilling.selectedItem':     'There are {selectedItems} selected {entityType} ({totalItems} in total)',
    'label.cloudBilling.selectedBookmark': '{selectedItems} {entityType} this month ({totalItems} saved in bookmark)',
    'label.breakdown.entityTab':           'There are {totalItems} {entityType} in total',

    RESOURCES:               'Resources',
    STORAGE:                 'Storage',
    BACKUP:                  'Backup',
    CLOUD_BILLING:           'Cloud Billing',
    EXPORT_ACTION:           'download',
    EXPORT_SUCCESS:          'The report was downloaded successfully',
    EXPORT_ERROR:            'There was an error to download the report',
    ERROR_WEBSOCKET:         'There was an error during the conexion',
    'download.notification': 'You can download your file here: ',
    nextFeaturesMessage:     'This feature will be available soon. Thanks!',
    customSelection:         'Custom selection',

    websocketsDownloadMessage:            'You will receive a notification when the report is available',
    'title.alert.cloudBillingWebSockets': 'Download report',
    webSocketsDownloadError:              'There was an error creating the report',

    'title.alert.monitoringHost':             'Hosts',
    'title.alert.monitoringAlarms':           'Events',
    'title.alert.monitoringClientsId':        'CI by serverity',
    'title.alert.monitoringClientsIdClasses': 'CI by CI class',
    'title.alert.monitoringDaysBySeverity':   'Events severity daily',
    'title.alert.monitoringEvents':           'Events by severity',
    'title.alert.monitoringObjectsId':        'Object class by severity',
    'Cloud Billing':                          'Cloud Billing',

    'title.impersonate':        'Impersonate',
    'btn.returnImpersonate':    'Return to your user',
    'label.impersonate.search': 'Name, email, customer, account...',

    'label.azureToken.error':   'Azure CSP token could not be updated',
    'label.azureToken.success': 'Azure CSP token updated',

    'title.modal.deleteBookmark':       'Delete bookmark',
    'text.modal.deleteBookmark':        'Are you sure you want to remove the following bookmark?',
    'text.modal.deleteBookmark.accept': 'Yes, remove bookmark',

    'title.serviceNotFound':         'Are you interested to hire this service?',
    'title.serviceNotFound.service': '{service}',

    // CLOUD BILLING TOGGLE BUTTON
    'btn.aggregate': 'Aggregate',

    // CUSTOMER VOICE
    'customer-voice-title':        'Customer Voice',
    'customer-voice-description1': 'We want to hear from you. Customer experience matters to us and we want to hear what we can improve or what we are doing well.',
    'customer-voice-description2': 'You can reach us throught:',
    'customer-voice-option1':      'Getting in contact with your Service Manager',
    'customer-voice-option2':      'Completing Tickets Surveys',
    'customer-voice-option3':      'Clicking',
    'customer-voice-option4':      'Here',
    'customer-voice-thanks':       'Thank you!',

    // NOT AUTHORIZED
    publicCloud: 'Public cloud',
    hybridCloud: 'Hybrid Cloud',

    'notAuthorized.accessDenied': 'Access denied',

    'notAuthorized.contact': 'To request information about this service, please get in touch with your assigned Account Executive or send an email to:',

    'notAuthorized.backups.description':                 'Keep your critical information safe and replicated with Equinix Backup service. We offer 3 types of backups:',
    'notAuthorized.backups.option1.name':                'Smart backup:',
    'notAuthorized.backups.option2.name':                'Remote backup:',
    'notAuthorized.backups.option3.name':                'Cloud protection:',
    'notAuthorized.backups.option1.description':         'Infrastructure within our IBX’s.',
    'notAuthorized.backups.option2.description':         'Infrastructure on your side.',
    'notAuthorized.backups.option3.description':         'Infrastructure in the public cloud.',
    'notAuthorized.backups.feature.title':               'Main features:',
    'notAuthorized.backups.feature.option1':             'Service operated, monitored, and supported 24x7.',
    'notAuthorized.backups.feature.option2':             'Deduplication, encryption of data at source and destination.',
    'notAuthorized.backups.feature.option3':             'Backup copy incremental with no limit and full synthetics backups.',
    'notAuthorized.backups.feature.option4.name':        'Optional:',
    'notAuthorized.backups.feature.option5.name':        'Retention policies:',
    'notAuthorized.backups.feature.option4.description': 'Double copy, 3rd party integrations, cross copy, etc.',
    'notAuthorized.backups.feature.option5.description': 'Basic, standard and extended.',

    'notAuthorized.eqxIaas.description':     'Equinix offers the  IaaS service, which allows you to deploy your own flexible and powerful Cloud  infrastructure and based on leading standards and technologies in the market. Main characteristics:',
    'notAuthorized.eqxIaas.option1':         'Auto-provision portal of the Virtual Data Center',
    'notAuthorized.eqxIaas.option2':         'Network services defined by Software network (SDN) and Gateway capabilities (Routing, Balancing, NAT, VPN, etc).',
    'notAuthorized.eqxIaas.option3':         'Four locations: MD1, MD2, BA1 y SA1.',
    'notAuthorized.eqxIaas.option4':         'Two modalities: Standars vDC or vDC Geo-extended (RPO =0).',
    'notAuthorized.eqxIaas.option5':         'Shared or dedicated tenancy models.',
    'notAuthorized.eqxIaas.option6':         'Two tier volumes: capacity and extreme performance.',
    'notAuthorized.eqxIaas.option7':         'Standard and custom OS and templates catalog.',
    'notAuthorized.eqxIaas.option8':         'Additional services:',
    'notAuthorized.eqxIaas.option8.option1': 'Internet access',
    'notAuthorized.eqxIaas.option8.option2': 'Ability to connect directly to P2P or MPLS (1Gbit and 10 Gbit ports).',
    'notAuthorized.eqxIaas.option8.option3': 'Antivirus',
    'notAuthorized.eqxIaas.option8.option4': 'License and BYOL provision',
    'notAuthorized.eqxIaas.option8.option5': 'NAS storage',

    'notAuthorized.monitoring.description': 'Equinix monitoring service will help you to detect, log and be notified about incidents in your IT environments. We offer a suite of specifics tools for different use cases:',
    'notAuthorized.monitoring.option1':     'One single graphic interphase.',
    'notAuthorized.monitoring.option2':     'Automatic notification and calls to defined groups (MANS).',
    'notAuthorized.monitoring.option3':     'Events correlations.',
    'notAuthorized.monitoring.option4':     'Flexible collection of system and service metrics.',
    'notAuthorized.monitoring.option5':     'Create events based on availability or performance.',
    'notAuthorized.monitoring.option6':     'Daily reports of events and alarms.',
    'notAuthorized.monitoring.option7':     'Integration with our ITSM tool to help you keep track of your alerts.',

    'notAuthorized.smartmonitoring.description': 'Equinix offers its monitoring service which allows you to detect, log and be notified about incidents in your IT environments. We offer a suite of specialized tools for each environment, offering multiple benefits:',
    'notAuthorized.smartmonitoring.option1':     'Access from any device.',
    'notAuthorized.smartmonitoring.option2':     'Customize your dashboard by service.',
    'notAuthorized.smartmonitoring.option3':     'Easy-to-use graphic interphase',
    'notAuthorized.smartmonitoring.option4':     'Hybrid environment metric setup like On-prem, Equinix IaaS, AWS, GCP, Azure, OCI, Alicloud.',

    'notAuthorized.publiccloud.description1': 'Equinix offers the Public Cloud Reselling service, which is the most renowned in the market and  allows you to work with all major cloud providers since its establishment in Europe being Premier partners of Amazon Web Services, Google Cloud, Microsoft Azure Gold Partner, Oracle Cloud y Alibaba Cloud.',
    'notAuthorized.publiccloud.description2': 'Our expert engineer team, with more than 150 certifications in different cloud areas, will help you find and design a strategy to create and migrate your infrastructures to any of the major cloud providers. Inside this portal, Cloudglass, you can see your cloud usages in all your cloud providers in a simplified way. This tool is free of charge for our Reselling service´s customers.',

    'notAuthorized.hybridcloud.description1':   'The aim of Equinix is to accompany our customers in their path to digital transformation. To do so, it is essential to use hybrid cloud solutions that allow our customers to enjoy the benefits of both private and public cloud.',
    'notAuthorized.hybridcloud.description2':   'Equinix, through its ',
    'notAuthorized.hybridcloud.description2.2': ' service, allows private and secure connections to be established in minutes through the Equinix Fabric\'s service portal, with a variety of service providers.',

    'notAuthorized.iaas.description1': 'Infrastructure Platform Service (IPS) provides a virtual datacenter service, complete defined by software, covering compute, network and storage layer, using an auto-provisioning tool.',
    'notAuthorized.iaas.description2': 'Service provides different availability zones that allow to deploy Virtual Datacenters in our IBXs (MD1, MD2, BA1, SA1), working in an independent way or combine between them deploying a Geoextended Virtual Datacenter (MD1-MD2)',
    'notAuthorized.iaas.description3': 'We offer two different compute modalities:',
    'notAuthorized.iaas.option1':      'Flexible Compute: This modality provides our customer IT resources (vCPU and vRAM), storage and network devices in a shared platform for virtual hosting of all the resources to offer maximum flexibility on the devices sizing.',
    'notAuthorized.iaas.option2':      'Dedicated Host: This modality provides compute (vCPU and vRAM) for exclusive use and dedicated for our customers. These resources are provided with physical virtualization servers dedicated for the customer but keeping same tools and functionalities as Flexible Compute does.',

    'notAuthorized.storage.description':                 'Equinix offers its storage service to store customer data privately, securely, fault-tolerant, and in pay-per-use consumption. Two modalities are offered:',
    'notAuthorized.storage.option1':                     'Storage SAN: Block mode storage accessible via FC protocol through redundant low-latency SAN networks.',
    'notAuthorized.storage.option2':                     'Storage NAS: File mode storage accessible through CIFS or NFS protocol through redundant Ethernet networks.',
    'notAuthorized.storage.feature.title':               'Main features:',
    'notAuthorized.storage.feature.option1':             'Service operated, monitored, and supported 24x7.',
    'notAuthorized.storage.feature.option2':             'Available in different types of disk: Extreme Performance (SSD) and Capacity (NL-SAS).',
    'notAuthorized.storage.feature.option3':             'Redundant systems in all components and with cache modules to accelerate IO operations.',
    'notAuthorized.storage.feature.option4':             'Integration with VMWare VAAI',
    'notAuthorized.storage.feature.option5.name':        'Optional services:',
    'notAuthorized.storage.feature.option5.description': 'Storage geoextended active/active access, asynchronous replication with minimal RPO and snapshots/clones.',

    // WIZARD
    'label.credentials.initial.state': 'Select an account',
    'label.credentials.second.state':  'Choose one service',
    'label.credentials.third.state':   'Add and Save your credentials',

    //Check Version
    'title.modal.checkVersion':       'New update',
    'text.modal.checkVersion.accept': 'Reload',
    'description.modal.checkVersion': 'A new version of Cloudglass has been detected. Please reload the application.',

    // Not available
    'text.not.available': 'Access to managed services is temporarily disabled for maintenance.',

    // Storage reports
    'title.storage.NAS':                      'NAS',
    'title.storage.SAN':                      'SAN',
    'title.storage.objects':                  'Objects',
    'title.storage.detail':                   'Details',
    'title.storage-reports':                  'Storage reports',
    'title.storagePlatform':                  'Storage',
    'chart.storage.occupancy':                'Storage occupancy',
    'chart.storage.assigned':                 'Storage assigned (TB)',
    'chart.label.assigned':                   'Assigned',
    'chart.label.free':                       'Free',
    'chart.label.used':                       'Used',
    'storage.select.volume.placeholder':      'Select a volume',
    'storage.select.bucket.placeholder':      'Select a bucket',
    'storage.select.volume.title':            'Volumes',
    'storage.select.volume.loading':          'Loading volumes...',
    'storage.select.bucket.loading':          'Loading Buckets...',
    'storage.table.column.ibx':               'IBX',
    'storage.table.column.replicaType':       'Replica type',
    'storage.table.column.volumeName':        'Volume name',
    'storage.table.column.assignedSpace':     'Assigned space',
    'storage.table.column.usedSpace':         'Used space',
    'storage.table.column.descPoe':           'Desc Poe',
    'storage.table.column.serviceName':       'Service name',
    'storage.table.entity.singular':          'storage',
    'storage.table.entity.plural':            'storages',
    'storage.table.filter.columnFilter':      'Column to search',
    'storage.table.filter.storageTechnology': 'Storage technology',
    'storage.table.filter.search':            'Value to search in the column...',
    'title.alert.storageAssigned':            'Storage assigned',
    'title.alert.storageOccupancy':           'Storage occupancy',
    'title.alert.storageVolume':              'Storage volume',
    'title.alert.storageDetail':              'Storage detail',

    // CMDB
    'title.cmdbReports':                                       'CMDB & Reports',
    'title.cmdb-dashboard':                                    'CMDB dashboard',
    'title.cmdb-reports':                                      'Reports',
    'cmdb.allDevices':                                         'All devices',
    'cmdb.OperatedByEquinixSupport':                           'Devices operated by Equinix',
    'cmdb.NoOperatedByEquinix':                                'Devices non operated by Equinix',
    'title.cmdb.globalCMDBInformation':                        'CMDB global information',
    'title.cmdb.tab.globalCMDBInformation':                    'CMDB global information',
    'chart.cmdb.globalCMDBCake':                               'CMDB Active CIs',
    'chart.cmdb.globalCMDBLast13Months':                       'CMDB Active CIs (Last 13 months)',
    'chart.cmdb.globalCMDBLast13Months.label':                 'Active CIs',
    'chart.cmdb.CMDBBackupCake':                               'Backup',
    'chart.cmdb.CMDBBackupLast13m':                            'Backup (Last 13 months)',
    'chart.cmdb.CMDBBackupCake.withBackup.label':              'CIs with backup',
    'chart.cmdb.CMDBBackupCake.withoutBackup.label':           'CIs without backups',
    'chart.cmdb.CMDBMonitoringCake':                           'Monitoring Platform',
    'chart.cmdb.CMDBMonitoringCake.withMonitoring.label':      'CIs with monitoring',
    'chart.cmdb.CMDBMonitoringCake.withoutMonitoring.label':   'CIs without monitoring',
    'chart.cmdb.CMDBMonitoringLast13m':                        'Monitoring platform (Last 13 months)',
    'chart.cmdb.CMDBPatchCake':                                'Patch process',
    'chart.cmdb.CMDBPatchCake.withPatch.label':                'CI with patch',
    'chart.cmdb.CMDBPatchCake.withoutPatch.label':             'CI without patch',
    'chart.cmdb.CMDBPatchLast13m':                             'Patch process (Last 13 months)',
    'title.cmdb.CMDBDetails':                                  'CMDB details',
    'title.cmdb.tab.CMDBDetails':                              'CMDB details',
    'cmdb.table.service.column.ci_name':                       'CI name',
    'cmdb.table.service.column.class_name':                    'Class name',
    'cmdb.table.service.column.with_backup':                   'Backup',
    'cmdb.table.service.column.last_backup':                   'Last backup date',
    'cmdb.table.service.column.with_monitoring':               'Monitoring',
    'cmdb.table.service.column.windows_patch':                 'Patching windows',
    'cmdb.table.service.column.last_patch_date':               'Last patch date',
    'cmdb.table.service.column.patch_status':                  'Patch status',
    'cmdb.table.service.column.managed':                       'Managed',
    'cmdb.table.service.column.patch_status.patched':          'OK',
    'cmdb.table.service.column.patch_status.reached_eol':      'EOL',
    'cmdb.table.service.column.patch_status.no_patch_windows': 'No patching windows',
    'cmdb.table.service.column.patch_status.warning':          'Warning',
    'cmdb.table.service.column.patch_status.not_patched':      'Not patched',
    'cmdb.table.service.column.patch_status.not_upgradable':   'Not patched',
    'cmdb.services.table.entity.singular':                     'service',
    'cmdb.services.table.entity.plural':                       'services',
    'cmdb.devices.table.entity.singular':                      'device',
    'cmdb.devices.table.entity.plural':                        'devices',
    'cmdb.title.widget.services_details':                      'Services details',
    'cmdb.title.widget.devices_details':                       'Devices details',
    'cmdb.table.device.column.ci_name':                        'CI name',
    'cmdb.table.device.column.class_name':                     'Class name',
    'cmdb.table.device.column.operating_system':               'Operating system',
    'cmdb.table.device.column.eol':                            'Operating System EoL',
    'cmdb.table.device.column.manufacturer':                   'Manufacturer',
    'cmdb.table.device.column.memory_gb':                      'Memory',
    'cmdb.table.device.column.cpu':                            'CPU',
    'cmdb.table.device.column.cpu_core':                       'Cores',
    'cmdb.table.device.column.model':                          'Model',
    'cmdb.table.service.label.yes':                            'Yes',
    'cmdb.table.service.label.no':                             'No'
};



// WEBPACK FOOTER //
// ./src/locales/en.js